import styled from 'styled-components';
import { breakpoint } from 'variables';
import Card from 'components/generic/card';
import type { ICard } from 'components/generic/card/shared/types';
import type { ResponsiveImageModelMaybe } from 'autogen/swagger/all';
import { BorderRadiusMedium } from 'autogen/design-tokens/tokens';
import type { HTMLAttributes, ReactNode } from 'react';
import Picture from 'components/generic/picture/Picture';
import mapResponsiveImageModelToPictureProps from 'components/generic/picture/helpers/mappingHelper';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;

    ${breakpoint.up('768px')} {
        grid-template-columns: 1fr 1fr;
    }
`;

const ImageContainer = styled.div`
    display: none;

    ${breakpoint.up('768px')} {
        position: relative;
        display: block;
        border-radius: ${BorderRadiusMedium} 0 0 ${BorderRadiusMedium};
        overflow: hidden;
    }
`;

const StyledCard = styled(Card)`
    ${ImageContainer} ~ & {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
`;

const StyledPicture = styled(Picture)`
    img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export type ImageCardProps = HTMLAttributes<HTMLDivElement> & {
    cardRenderer?: (props: ICard) => ReactNode;
    image?: ResponsiveImageModelMaybe;
};

const DefaultCardRenderer = (props: ICard) => <StyledCard {...props} />;

export default function ImageCard(props: ImageCardProps) {
    const { image, children, cardRenderer = DefaultCardRenderer, ...restProps } = props;

    return (
        <Wrapper {...restProps}>
            {image && (
                <ImageContainer>
                    <StyledPicture {...mapResponsiveImageModelToPictureProps(image, 400)} />
                </ImageContainer>
            )}
            {cardRenderer({ children })}
        </Wrapper>
    );
}
